import { useMemo } from 'react';

import {
  DROP_ITEM_SIZE,
  ViewProps,
} from '../settings/interactive-response.constants';
import InteractiveDragDisplay from 'approot/activity-builder/components/shared/interactive-drag-drop/interactive-drag-display';
import {
  InteractiveResponseViewScaler,
  InteractiveResponseTitle,
} from '../../shared/interactive-response-shared';
import {
  InteractiveResponsePreviewContainer,
  InteractiveStackDragContainer,
} from '../../shared/interactive-response-shared.style';
import { initialise } from './interactive-response-sequence.utils';
import * as Styled from './interactive-response-sequence.style';
import InteractiveSequenceDropDisplay from './interactive-sequence-drop-display';

const InteractiveResponseSequenceStatic = ({ properties }: ViewProps) => {
  const { dragItems, dropItems } = useMemo(() => {
    return initialise(
      properties.interactiveResponse.variant,
      properties.interactiveResponse.items,
      false
    );
  }, [
    properties.interactiveResponse.variant,
    properties.interactiveResponse.items,
  ]);

  return (
    <InteractiveResponseViewScaler>
      <InteractiveResponseTitle
        title={properties.interactiveResponse.title}
        subTitle={properties.interactiveResponse.subTitle}
      />

      <InteractiveResponsePreviewContainer>
        {dragItems.map((dragItem, index) => (
          <InteractiveStackDragContainer
            key={`${dragItem.id}-${index}`}
            $index={index}
          >
            {!dragItem.isDropped && (
              <InteractiveDragDisplay
                scaleTo={DROP_ITEM_SIZE}
                imageUrl={dragItem.question.image?.small}
                isFit={dragItem.question.image?.isFit}
                description={dragItem.question.image?.description || ''}
                baseColour={dragItem.question.baseColour}
                variant={dragItem.question.variant}
                text={dragItem.question.text}
                richtext={dragItem.question.richtext}
              />
            )}
          </InteractiveStackDragContainer>
        ))}
      </InteractiveResponsePreviewContainer>

      <Styled.InteractiveResponsePreviewDropItemContainer>
        {dropItems.map(dropItem => (
          <InteractiveSequenceDropDisplay
            key={`${dropItem.id}`}
            label={dropItem.label}
            labelLength={properties.interactiveResponse.labelLength}
            labelBorder={properties.interactiveResponse.labelBorder}
          />
        ))}
      </Styled.InteractiveResponsePreviewDropItemContainer>
    </InteractiveResponseViewScaler>
  );
};

export default InteractiveResponseSequenceStatic;
